// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_G3C","title":"styles_title__2K7fP"};